import { render, staticRenderFns } from "./BeneficiariesCPT.vue?vue&type=template&id=1ec7e77c&scoped=true&"
import script from "./BeneficiariesCPT.vue?vue&type=script&lang=js&"
export * from "./BeneficiariesCPT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec7e77c",
  null
  
)

export default component.exports